import { Navigate, useLocation } from "react-router-dom";
import type { ReactElement } from "react";

import { useAuthStore } from "../stores/auth";

/**
 * Route guard. Children render only when the auth store has a token;
 * otherwise the user is bounced to /login with `from` preserved in
 * navigation state so the post-login redirect lands them where they
 * were trying to go.
 */
export function AuthGuard({ children }: { children: ReactElement }): ReactElement {
  const token = useAuthStore((state) => state.token);
  const location = useLocation();

  if (token === null || token === "") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
